import cx from "classnames";
import { find, get } from "lodash";
import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBContainer,
  MDBRow
} from "mdbreact";
import React from "react";
import { connect } from "react-redux";
import PKHBtn from "~/components/common/atoms/Button";
import Select from "~/components/common/atoms/Select";
import TagName from "~/components/common/atoms/TagName";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import PatientInfomationLess from "~/components/desktop/molecules/PatientInfomationLess";
import { partnerInfo } from "~/configs/partnerDetails";
import { setInsuranceChoice } from "~/store/totalData/actions";
import { routerByPartnerId } from "~/utils/func";
import styles from "./style.module.scss";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

class InstructionIncorrectBHYT extends React.Component {
  constructor(props) {
    super(props);
    this.listInCorrectBHYT = [
      { id: "TAI_KHAM", name: `Tái khám theo lịch hẹn` },
      {
        id: "CHUYEN_TUYEN",
        name: `Chuyển tuyến`
      }
    ];
  }

  handleContinueAction = () => {
    const { partnerId, history } = this.props;
    const route = routerByPartnerId("/xac-nhan-thong-tin", partnerId);
    history.push(route);
  };

  handleGoBack = () => {
    let route = "";
    route = "/chon-ho-so";
    this.props.history.push({
      pathname: route
    });
  };

  handleChangeType = id => {
    this.props.setInsuranceChoice({
      insurance: id
    });
  };

  render() {
    return (
      <div className={styles.wapper_page_desktop}>
        <MDBContainer>
          <MDBRow className="row_mobile">
            <MDBCol md="12" lg="3">
              <PatientInfomationLess />
            </MDBCol>
            <MDBCol md="12" lg="9">
              <MDBCard className={cx(styles.panels, styles.panel_mobile)}>
                <MDBCardHeader className={styles.panels_header}>
                  <TagName
                    element="h2"
                    className={[
                      "title_component",
                      "title_choose_date",
                      "space_between",
                      "title_header_mobile"
                    ]}
                  >
                    <span>
                      Quy định dành cho bệnh nhân khám Bảo hiểm (Trái Tuyến)
                    </span>
                  </TagName>
                </MDBCardHeader>
                <MDBCardBody className={styles.card_body}>
                  <div className={styles.list_type}>
                    <span>Vui lòng chọn hình thức bảo hiểm</span>
                    <Select
                      data={this.listInCorrectBHYT}
                      onChange={this.handleChangeType}
                    />
                  </div>
                  <div className={styles.list_type}>
                    <span>
                      Vui lòng xác nhận có các loại giấy tờ sau khi đến khám
                      bệnh:
                    </span>
                    {this.props.insuranceChoice === "TAI_KHAM" ? (
                      <div className={styles.instruction}>
                        - Thẻ Bảo hiểm Y tế còn hạn.
                        <br />- Giấy hẹn tái khám.
                      </div>
                    ) : (
                      <div className={styles.instruction}>
                        - Thẻ Bảo hiểm Y tế còn hạn.
                        <br />- Giấy chuyển tuyến hợp lệ
                      </div>
                    )}
                  </div>
                </MDBCardBody>
                <div className={styles.next_prev}>
                  <PKHBtn backdesktop="backdesktop" onClick={this.handleGoBack}>
                    Quay lại
                  </PKHBtn>
                  <PKHBtn
                    onClick={this.handleContinueAction}
                    buttonArrow="buttonArrow"
                    nextStep
                    create="create"
                  >
                    Tiếp tục
                  </PKHBtn>
                </div>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    totalData: {
      service: { insuranceChoice },
      partnerId
    }
  } = state;
  return {
    insuranceChoice,
    partnerId
  };
};

const InstructionIncorrectBHYTHelmet = withTitle({
  component: InstructionIncorrectBHYT,
  title: `${hospitalName.value} | Hướng dẫn BHYT`
});

export default connect(mapStateToProps, { setInsuranceChoice })(
  InstructionIncorrectBHYTHelmet
);
